module.exports = __webpack_public_path__ + "static/riley-5-fa1a5a4b3a700d801e7e93390f2485ac.jpg";